/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited 2023.
 */

import { getContentRecommendation } from '@/data/Content/ContentRecommendation-Server';
import { useESpotDataFromName } from '@/data/Content/_ESpotDataFromName';
import { ID } from '@/data/types/Basic';
import {
	dataMapContent as dataMap,
	dataMapJsonContent as dataMapJson,
	dataMapTitleContent,
	dataMapESpotName,
} from '@/data/utils/dataMapContent';
import { useMemo } from 'react';
export { dataMap, getContentRecommendation };

export const useContentRecommendation = (emsName: ID, isJsonAccordion?: boolean) => {
	const { data: _data, error, loading } = useESpotDataFromName(emsName);
	const data = useMemo(() => dataMap(_data), [_data]);
	const title = useMemo(() => dataMapTitleContent(_data), [_data]);
	const eSpotName = useMemo(() => dataMapESpotName(_data), [_data]);
	const jsonEspotData = useMemo(
		() => isJsonAccordion && dataMapJson(_data),
		[_data, isJsonAccordion]
	);

	return {
		eSpotName,
		jsonEspotData,
		data,
		loading,
		error,
		title,
	};
};
